import { error, finish } from '../../../modules/markets/actions/add-rule4';
import api from '../../../api';

export function request(dispatch, { eventId, marketId, data }) {
    api.post(`/events/${eventId}/markets/${marketId}/rule4`, data)
        .then(
            market => {
                market.selections = Object.keys(market.selections).map(x => market.selections[x]);

                dispatch(finish(marketId, market));
            },
            errors => dispatch(error(marketId, errors))
        );
}
